import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";
 
const FrontRoute = memo(function UserRoute({ children }) {
  return children 
});
export default FrontRoute;
